export enum Locale {
  EN = 'en',
  ES = 'es',
}

export interface MultiStageGrowthReportInput {
  classId: string;
  rootProgramId: string;
  subject?: string;
}
